import { Autocomplete, TextField } from "@mui/material";
import { ProjectUserRoleFilterDto } from "../../../models/advancedFilters";

interface RolesFilterOptionProps {
  options: ProjectUserRoleFilterDto[];
  value: ProjectUserRoleFilterDto[];
  onChange: (value: ProjectUserRoleFilterDto[]) => void;
}

const RolesFilterOption = ({
  options,
  value,
  onChange,
}: RolesFilterOptionProps): JSX.Element => (
  <Autocomplete
    multiple
    options={options}
    getOptionLabel={(option) => option.name}
    value={value}
    onChange={(_event, newValue) => onChange(newValue)}
    isOptionEqualToValue={(option, val) => option.id === val.id}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Roles"
        placeholder="Select roles"
        size="small"
      />
    )}
  />
);

export default RolesFilterOption;
